module.exports = __webpack_public_path__ + "img/ava.14bf4433.png";